import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
var MenuService = /** @class */ (function () {
    function MenuService(router) {
        var _this = this;
        this.router = router;
        this.lastState = false;
        this.state$ = new Subject();
        router.events
            .pipe(filter(function (e) { return e instanceof NavigationEnd; }))
            .subscribe(function (e) { return _this.close(); });
    }
    MenuService.prototype.toggle = function () {
        this.state$.next(this.lastState = !this.lastState);
    };
    MenuService.prototype.close = function () {
        this.state$.next(this.lastState = false);
    };
    return MenuService;
}());
export { MenuService };
//# sourceMappingURL=menu.service.js.map